import React, {Component, Fragment} from 'react';
import {withTranslation, Trans} from 'react-i18next';
import {route} from "../../../routes";
import {Helmet} from "react-helmet";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {GelContentContainer, withAuthentication, Button, Notice} from "cw-styleguide-react";

class UnauthenticatedView extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.landing.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('landing')}>
          {this.props.t('view.unauthenticated.breadcrumb')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('local:view.unauthenticated.title')}</h1>
        </GelContentContainer>
        <GelContentContainer>
          <Notice type={'info'}>
            <Trans i18nKey="local:view.unauthenticated.introduction"
                   components={[<Button asLink={true} onClick={this.props.authentication.login}></Button>]}/>
          </Notice>
        </GelContentContainer>
      </Fragment>
    )
  }

}

export default withAuthentication(withTranslation('local')(UnauthenticatedView));
